module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-date-picker', {
    attrs: {
      "type": "month",
      "clearable": false,
      "editable": false,
      "placeholder": "查询月份"
    },
    model: {
      value: (_vm.filters.flowmonth),
      callback: function($$v) {
        _vm.$set(_vm.filters, "flowmonth", $$v)
      },
      expression: "filters.flowmonth"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "输卡号/ICCID/IMSI/查询码"
    },
    model: {
      value: (_vm.filters.msisdn),
      callback: function($$v) {
        _vm.$set(_vm.filters, "msisdn", $$v)
      },
      expression: "filters.msisdn"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.getFlowInfoList
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.exportData()
      }
    }
  }, [_vm._v("导出EXCEL")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.flowInfo,
      "highlight-current-row": ""
    },
    on: {
      "selection-change": _vm.selsChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "msisdn",
      "label": "卡号",
      "width": "200",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "iccid",
      "label": "ICCID",
      "width": "200",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "imsi",
      "label": "IMSI",
      "width": "200",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "flowmonth",
      "label": "所属月份",
      "width": "200",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "querycode",
      "label": "查询代码",
      "width": "200",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "servicename",
      "label": "所属用户",
      "width": "180",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "apicode",
      "label": "所属API",
      "width": "180",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "gprsused",
      "label": "本月已用流量(MB)",
      "width": "200",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "flowthreshold",
      "label": "流量阀值(MB)",
      "width": "200",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "excessflow",
      "label": "超出流量值(MB)",
      "width": "200",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "80",
      "fixed": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.getflowDetails(scope.$index, scope.row)
            }
          }
        }, [_vm._v("详情")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "预警详情信息",
      "visible": _vm.flowDetailVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.flowDetailVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "flowDetail",
    attrs: {
      "label-width": "100px",
      "model": _vm.flowDetail
    }
  }, [_c('div', {
    staticStyle: {
      "overflow": "auto",
      "width": "100%"
    }
  }, [_c('table', {
    staticClass: "border-table"
  }, [_c('tr', [_c('td', {
    staticClass: "alt"
  }, [_vm._v("卡号：")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.flowDetail.msisdn))]), _vm._v(" "), _c('td', {
    staticClass: "alt"
  }, [_vm._v("ICCID:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.flowDetail.iccid))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "alt"
  }, [_vm._v("IMSI:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.flowDetail.imsi))]), _vm._v(" "), _c('td', {
    staticClass: "alt"
  }, [_vm._v("查询代码：")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.flowDetail.querycode))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "alt"
  }, [_vm._v("所属用户:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.flowDetail.servicename))]), _vm._v(" "), _c('td', {
    staticClass: "alt"
  }, [_vm._v("所属API:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.flowDetail.apicode))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "alt"
  }, [_vm._v("本月已用流量(MB)：")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.flowDetail.gprsused))]), _vm._v(" "), _c('td', {
    staticClass: "alt"
  }, [_vm._v("流量阀值(MB):")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.flowDetail.flowthreshold))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "alt"
  }, [_vm._v("超出流量值(MB):")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.flowDetail.excessflow))])])])])])], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "current-page": _vm.currentPage,
      "page-sizes": [10, 20, 50, 100],
      "page-size": _vm.pageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-12036ba9!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/nav2/traffic_warning.vue
// module id = 725
// module chunks = 2